import {
    AUTH_LOGIN,
    AUTH_LOGIN_CHECK,
    AUTH_LOGIN_FAILURE,
    AUTH_LOGIN_SUCCESS,
} from 'store/actions/types';

export const authLogin = (payload) => {
    return {
        type: AUTH_LOGIN,
        payload: payload,
    };
};

export const authLoginCheck = (payload) => {
    return {
        type: AUTH_LOGIN_CHECK,
        payload: payload,
    };
};

export const authLoginFailure = (error) => {
    return {
        type: AUTH_LOGIN_FAILURE,
        error: error,
    };
};

export const authLoginSuccess = () => {
    return {
        type: AUTH_LOGIN_SUCCESS,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/auth/authLogin.js